import { IEvent } from '@samc/common';

export class LoanSyncEvent implements IEvent {
  static eventName: 'LoanSyncEvent' = 'LoanSyncEvent';
  public name: string = LoanSyncEvent.eventName;
  constructor(public itemIds: string[], public isWindowOpen: boolean) { }
}
